import Group from 'components/utils/Group'
import BedbankOfferPriceDetails from './BedbankOfferPriceDetails'
import WalledContent from 'components/Common/WalledContent'
import OfferTileLoggedInButtons from '../OfferListTiles/Support/OfferTileLoggedInButtons'
import { ViewOfferButton } from './ViewOfferButton'

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary | App.BedbankOfferWithRate
  variant?: 'default' | 'condensed'
  selectedDatesAndRoomsFilter?: App.OfferListFilters
  filters?: App.OfferListFilters
  /** Optional authoritative pricing, retaining the standard View button and access gate. */
  PricingComponent?: React.ComponentType
  /**
   * Chat-carousel override: when provided, the price block and View button are
   * replaced by this CTA (e.g. a "Select dates" prompt for a no-date bedbank
   * offer whose price must be withheld). Defaults to the standard price + View.
   */
  CtaComponent?: React.ComponentType
  showViewButton?: boolean
}

function BedbankOfferCardPriceDetails(props: Props) {
  const { offer, variant = 'default', selectedDatesAndRoomsFilter, filters, CtaComponent, PricingComponent, showViewButton = true } = props

  const wall =
    <OfferTileLoggedInButtons
      discountLabelAlign="end"
      align="right"
      fullWidth={false}
    />

  return <Group direction="horizontal" gap={8} horizontalAlign={CtaComponent ? 'end' : 'space-between'} verticalAlign="end">
    <WalledContent enforced={offer.walledGarden} hidePricing={offer.hidePricing} wall={wall}>
      {CtaComponent
        ? <CtaComponent />
        : <>
            <div>
              {PricingComponent ? <PricingComponent /> : <BedbankOfferPriceDetails offer={offer} selectedDatesAndRoomsFilter={selectedDatesAndRoomsFilter} filters={filters} />}
            </div>
            {showViewButton && <ViewOfferButton variant={variant} />}
        </>}
    </WalledContent>
  </Group>
}

export default BedbankOfferCardPriceDetails
